import ApiClient from './apiClient';
import { Http } from 'vue-resource/types/vue_resource';
import { ApiConfig } from '@/configs/apiConfig';
import { Product } from './models/product';
import { PresetSet } from './models/preset';
import { productAdapter } from './adapters/productAdapter';
import { presetAdapter } from './adapters/presetAdapter';
import { stringUtil } from '@/models/stringUtil';
import { Config } from './models/config';
import { configAdapter } from './adapters/configAdapter';
import { PresetData } from '../presets';
import { ISapElement, SapElement } from './models/sapElement';
import store from '@/store';
import { ISimpleSapElement } from './models/simpleSapElement';
import { Calculation } from './models/calculation';

export default class RestApiClient implements ApiClient {

    constructor(
        private http: Http,
        private config: ApiConfig,
    ) { }

    public test(): PromiseLike<number> {
        const url = stringUtil.createUrl('test');
        return this.http.get(url).then((x) => Number(x.data));
    }

    public getProduct(id: string): PromiseLike<Product> {
        const url = stringUtil.createUrl(`presets/template/${id}.json`);
        return this.http
            .get(url)
            .then((x) => productAdapter.adapt(x));
    }

    public getAllPresets(id: string): PromiseLike<PresetSet> {
        // const url = stringUtil.createUrl(`product/preset/all/${id}`);
        // return this.http.get(url).then((x) => presetAdapter.adpatArray(x));
        const complex = store.getters.configuration.appPreset;
        const inner = store.getters.configuration.appPresetInterior;
        const complexRequests = complex.map((x) => {
            return this.http.get(stringUtil.createUrl(x.url));
        });
        const innerRequests = inner.map((x) => {
            return this.http.get(stringUtil.createUrl(x.url));
        });
        return Promise.all([...complexRequests, ...innerRequests]).then((x) => {
            const c = x.splice(0, complex.length);
            const i = x;
            const preset = {} as any;
            preset.complete = c.map((value, index) => {
                return {
                    presetId: '',
                    projectId: store.getters.configuration.productId,
                    avatar: complex[index].avatar,
                    name: complex[index].name,
                    projectJson: JSON.stringify(value.data),
                };
            });
            preset.inner = i.map((value, index) => {
                return {
                    presetId: '',
                    projectId: store.getters.configuration.productId,
                    avatar: inner[index].avatar,
                    name: inner[index].name,
                    projectJson: JSON.stringify(value.data),
                };
            });
            const result = {
                complete: presetAdapter.adaptAnyArray(preset.complete),
                inner: presetAdapter.adaptAnyArray(preset.inner),
            };
            return result;
        });
    }

    public getConfig(id: string): PromiseLike<Config> {
        const url = stringUtil.createConfigUrl(id);
        return this.http
            .get(url)
            .then((x) => configAdapter.adapt(x));
    }

    public getCustomerPreset(url: string): PromiseLike<PresetData> {
        return this.http
            .get(url)
            .then((x) => PresetData.adapt(x.data));
    }

    public getSapConfig(): PromiseLike<ISapElement[]> {
        const url = store.getters.configuration.apiConfigErp;
        return this.http
            .get(url)
            .then((res) => Object.keys(res.data).map((x) => SapElement.adapt(res.data[x])));
    }

    public getPrice(elements: ISimpleSapElement[]): PromiseLike<Calculation> {
        const url = store.getters.configuration.orderCondCalcUrl;

        const productPreset = {
            ...store.getters.configuration.productPreset,
            dimension: {
                width: Math.ceil(store.getters.product.width * 2) / 20,
                height: Math.ceil(store.getters.product.height * 2) / 20,
                depth: Math.ceil(store.getters.product.depth * 2) / 20,
            },
            dimension_full: {
                width: store.getters.productFullWidth / 10,
                height: store.getters.productFullHeight / 10,
                depth: store.getters.productFullDepth / 10,
            },
        };

        const body = {
            schema: 'creative_erp',
            object: {
                elements_erp: elements,
                productPreset: productPreset,
            },
        };
        return this.http
            .post(url, body)
            .then((x) => Calculation.adapt(x.data));
    }

    public download(path: string): PromiseLike<any> {
        const url = stringUtil.createDownloadUrl(path);
        return this.http.get(url).then((x) => x.data);
    }

    public uploadPreset(
        id: string,
        json: string,
        base64: string,
        name: string,
        complex: boolean,
        prefix: string,
        empty: boolean,
    ): PromiseLike<boolean> {
        const url = stringUtil.getUploadPresetUrl();
        return this.http.post(url, {
            id,
            json,
            base64,
            name,
            complex,
            prefix,
            empty,
        }).then((x) => true);
    }
}
